// apps/web/components/ui/adapters/Badge.tsx
'use client';

import { Badge as BaseBadge, badgeVariants as baseBadgeVariants } from '../badge';
import type {
  BadgeProps as DSBadgeProps,
  BadgeVariant as DSBadgeVariant,
  BadgeSize as DSBadgeSize,
  Radius as DSRadius,
} from '@repo/design-system/types';

// Re-export the base component and its variants
const Badge = BaseBadge;
const badgeVariants = baseBadgeVariants;

// Re-export the design system types
export type BadgeProps = DSBadgeProps;
export type BadgeVariant = DSBadgeVariant;
export type BadgeSize = DSBadgeSize;
export type Radius = DSRadius;

export { Badge, badgeVariants };
